// extracted by mini-css-extract-plugin
module.exports = {"body":"_3tC1y1iC"};